<template>
	<v-container>
		<!-- Input para buscar coincidencias de lugares conforme al texto que va ingresando el usuario -->
		<!-- <gmap-autocomplete class="form-control" @place_changed="setPlace"></gmap-autocomplete> -->
		<v-row justify="center">
			<v-text-field
				id="map_address"
				label="Ejemplo: Varsovia 44, Juárez, Ciudad de México, CDMX"
				prepend-inner-icon="mdi-map-marker-radius"
				v-model="direccion_tecleada"
				v-on:change="busca_direccion()"
			>
				<template v-slot:append>
					<v-btn
						id="search_latidos"
						icon
						:class="claseBotonEliminar()"
						@click="continuar(false)"
					>
						<v-icon> mdi-magnify </v-icon>
					</v-btn>
				</template>
			</v-text-field>
		</v-row>

		<gmap-map
			:center="{ lat: ubicacionActual.lat, lng: ubicacionActual.lng }"
			:zoom="16"
			style="width: 100%; height: 400px; margin-top: 5%"
		>
			<gmap-marker
				:key="index"
				v-for="(m, index) in markers"
				:position="m.position"
				:clickable="true"
				:draggable="true"
				@click="center = m.position"
				@drag="actualiza_coordenadas"
			></gmap-marker>
		</gmap-map>
		<v-footer absolute class="font-weight-medium" padless>
			<v-btn
				id="confirmar_ubicacion_btn"
				x-large
				style="width: 100%"
				@click="continuar(true)"
				>GUARDAR</v-btn
			>
		</v-footer>
	</v-container>
</template>

<script>
// import { gmapApi } from "vue2-google-maps";
import Usuario from "@/objetos/usuario";

export default {
	components: {},
	data: () => ({
		markers: [
			// {
			//   position: { lat: 10.0, lng: 10.0 }
			// }
		],
		coordenadas: null,
		ubicacionActual: {
			lat: 0,
			lng: 0,
		},
		direccion_ingresada: "",
		setPlace: "",
		timeout: 0,
		direccion_tecleada: "",
	}),
	mounted() {
		this.geolocation();
		this.habilitarBotonGuardar(false);
		var search_container = document.getElementById("search_latidos_container");
		if(search_container) search_container.classList.remove(".v-btn--contained");
	},
	watch: {
		direccion_ingresada: function (val) {
			Usuario.direccion = val;
		},
		ubicacionActual: function (val) {
			Usuario.coordenadas = val;
		},
	},
	methods: {
		// Actualiza las coordenas conforme se mueve el marcardor de posición
		actualiza_coordenadas(location) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(
				function () {
					this.ubicacionActual = {
						lat: location.latLng.lat(),
						lng: location.latLng.lng(),
					};
					this.obtener_direccion();
					clearTimeout(this.timeout);
				}.bind(this),
				900
			);
		},
		geolocation: function () {
            /** YA SE REGISTRARÓN LAS COORDENADAS DEL USUARIO */
			if (Usuario.coordenadas.lat && Usuario.coordenadas.lng) {
				if (Usuario.direccion) {
					this.direccion_tecleada = Usuario.direccion;
				}
				this.ubicacionActual = {
					lat: Usuario.coordenadas.lat,
					lng: Usuario.coordenadas.lng,
				};
				this.markers.push({
					position: {
						lat: Usuario.coordenadas.lat,
						lng: Usuario.coordenadas.lng,
					},
				});
				this.busca_direccion();
			} else {
                /** Se obtiene la unicación del navegador */
				navigator.geolocation.getCurrentPosition((position) => {
					this.ubicacionActual = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					this.markers.push({
						position: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						},
					});
					setTimeout(() => {
						this.obtener_direccion();
					}, 500);
				});
			}
		},
		// Busca la dirección ingresada
		busca_direccion: function () {
            console.log("BUSCA DIRECCIÓN")
			var search = document.getElementById("search_latidos");
            if(!window.google) return
			var geocoder = new window.google.maps.Geocoder();
			geocoder.geocode(
				{
					address: this.direccion_tecleada,
				},
				(results, status) => {
					if (status === "OK") {
						this.ubicacionActual.lat = results[0].geometry.location.lat();
						this.ubicacionActual.lng = results[0].geometry.location.lng();
						search.classList.remove("latidos");
						if (this.ubicacionActual.lat && this.ubicacionActual.lng) {
							this.habilitarBotonGuardar(true);
							console.log("Ubicacion confirmada: ", this.direccion_tecleada);
							//this.direccion_ingresada = this.direccion_tecleada
							//this.setCoordenadas(this.ubicacionActual);
							this.markers = [];
							this.markers.push({
								position: {
									lat: this.ubicacionActual.lat,
									lng: this.ubicacionActual.lng,
								},
							});
						}
					} else {
						console.log("Direccion no encontrada: ", this.direccion_tecleada);
						this.direccion_ingresada = "";
						this.direccion_tecleada = "";
						this.habilitarBotonGuardar(false);
					}
				}
			);
		},
		// Obtiene el nombre de la dirección conforme a la ubicacion actual.
		obtener_direccion: function () {
			if (!this.ubicacionActual.lat) return;
			var geocoder = new window.google.maps.Geocoder();
			let latlng = new window.google.maps.LatLng(
				this.ubicacionActual.lat,
				this.ubicacionActual.lng
			);
			geocoder.geocode(
				{
					latLng: latlng,
				},
				(results, status) => {
					if (status === "OK") {
						//this.direccion_ingresada = results[0].formatted_address;
						this.direccion_tecleada = results[0].formatted_address;
						this.habilitarBotonGuardar(true);
					} else {
						console.error(status);
					}
				}
			);
		},
		setCoordenadas(val) {
			Usuario.coordenadas = val;
		},
		claseBotonEliminar() {
			if (this.direccion_tecleada.length) {
				return "latidos";
			}
			return "";
		},
		habilitarBotonGuardar(flag) {
			var btn = document.getElementById("confirmar_ubicacion_btn");
			if (flag) {
				btn.disabled = false;
				btn.style.color = "#ffffff";
				btn.style.backgroundColor = "#58C4B5";
			} else {
				btn.disabled = true;
				btn.style.backgroundColor = "rgba(0, 0, 0, 0.12)";
				btn.style.color = "rgba(0, 0, 0, 0.26)";
			}
		},
		continuar(flag) {
			var search = document.getElementById("search_latidos");
			var geocoder = new window.google.maps.Geocoder();
			geocoder.geocode(
				{
					address: this.direccion_tecleada,
				},
				(results, status) => {
					if (status === "OK") {
						this.ubicacionActual.lat = results[0].geometry.location.lat();
						this.ubicacionActual.lng = results[0].geometry.location.lng();
						search.classList.remove("latidos");
						if (this.ubicacionActual.lat && this.ubicacionActual.lng) {
							this.habilitarBotonGuardar(true);
							//this.direccion_ingresada = this.direccion_tecleada
							Usuario.direccion = this.direccion_tecleada;
							console.log("Ubicacion confirmada: ", this.direccion_ingresada);
							this.setCoordenadas(this.ubicacionActual);
							this.markers = [];
							this.markers.push({
								position: {
									lat: this.ubicacionActual.lat,
									lng: this.ubicacionActual.lng,
								},
							});
						}
						if (flag) {
							this.$router.go(-1);
						}
					} else {
						console.log("Direccion no encontrada: ", this.direccion_tecleada);
						this.direccion_ingresada = "";
						this.direccion_tecleada = "";
						this.$root.$emit("snackbar", {
							color: "error",
							texto: "Dirección no válida",
							timeout: 2000,
						});
						this.habilitarBotonGuardar(false);
					}
				}
			);
		},
	},
};
</script>
<style>
@keyframes latidos {
	from {
		transform: none;
	}
	80% {
		transform: scale(0.8);
	}
	to {
		transform: none;
	}
}
.latidos {
	color: #4285f4 !important;
	background-color: #ffffff;
	border-radius: 50%;
	animation: latidos 0.9s infinite;
}
</style>